import { z } from 'zod';
import { refineDuration, refineTableName } from './Refines';

export const JoinTypeOptions = [
  '',
  'inner',
  'left_outer',
  'right_outer',
  'full_outer',
] as const;

export const StreamTableSchema = z.object({
  streaming: z.boolean(),
  name: z
    .string({
      required_error: 'Table name is required',
    })
    .refine(...refineTableName),
  watermark: z
    .object({
      eventTimeColumn: z.string().optional(),
      delayThreshold: z
        .string()
        .optional()
        .refine(...refineDuration),
      dropDuplicates: z.array(z.string().optional()).optional(),
    })
    .optional(),
  alias: z
    .string()
    .refine(...refineTableName)
    .optional(),
  joinHidden: z.boolean().optional(),
  joinType: z.enum(JoinTypeOptions).optional(),
  joinExpr: z.string().optional(),
  aliasRequired: z.boolean().optional(),
});

export type StreamTableSchemaValues = z.infer<typeof StreamTableSchema>;

export const superRefineStreamTableSchema = (
  tables: StreamTableSchemaValues[],
  ctx: z.RefinementCtx,
  tableName: string = 'tables',
  offset: number = 0,
) => {
  tables.forEach((table, index) => {
    if (tables.length > 1 + offset && !table.alias) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Alias is required',
        path: [tableName, index, 'alias'],
      });
    }
    if (index > 0 + offset && !table.joinExpr) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Join expression is required',
        path: [tableName, index, 'joinExpr'],
      });
    }
    if (index > 0 + offset && !table.joinType) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Join type is required',
        path: [tableName, index, 'joinType'],
      });
    }
    if (table.streaming && !table.watermark?.eventTimeColumn) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Event time column is required',
        path: [tableName, index, 'watermark', 'eventTimeColumn'],
      });
    }
    if (table.streaming && !table.watermark?.delayThreshold) {
      ctx.addIssue({
        code: z.ZodIssueCode.custom,
        message: 'Delay threshold is required',
        path: [tableName, index, 'watermark', 'delayThreshold'],
      });
    }
  });
};
